import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useCookie } from "react-use";
import { useAuthState } from "store/store";
import { me, User } from "./api";

export const useProfile = () => {
  const { profile, setProfile, setToken, token } = useAuthState();

  const [loaded, setLoaded] = useState(false);

  const query = useQuery(["profile", token], me, {
    enabled: !!token,
    retry: false,
    onSuccess: (a) => {
      setProfile(a.data);
    },
    onError: (err) => {
      setToken(null);
      setProfile(null);
    },
  });

  const logout = () => {
    setToken(null);
    setProfile(null);
  };

  const refetchProfile = () => {
    query.refetch();
  };

  return {
    profile,
    logout,
    refetchProfile,
    isLoading: query.isLoading,
  };
};
